module.exports = __webpack_public_path__ + "static/media/golfer-2-a.577822c7.png";